import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { inChildren } from 'services/utils';

import { BackBtn, DeleteBtn, EditBtn } from 'components/buttons/Btn';
// import Toolbar from 'components/Toolbar';
import FooterBar from 'components/FooterBar';
import NotFoundItems from 'components/NotFoundItems';
import Progress from 'components/Progress';
import Rbac, { useCan } from 'components/Rbac';
import Screen from 'components/Screen';
import Tabs, { Tab } from 'components/Tabs';
import { show as showModalConfirm } from 'modals/Confirm';

import * as actions from './actions';
import ShowUserGroups from './ShowUserGroups';
import ShowUserInfo from './ShowUserInfo';
import ShowUserSessions from './ShowUserSessions';

class Container extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notFound: false
    };
  }
  componentDidMount() {
    this.handleGetOne();
  }

  handleGetOne = async () => {
    const { match: { params: { id } = {} } = {}, usersActions } = this.props;
    try {
      await usersActions.getOne(id);
    } catch (err) {
      this.setState({ notFound: true });
      // history.goBack();
    }
  };

  handleDelete = async () => {
    const { usersActions, record = {}, dispatch, history = {} } = this.props;

    const res = await dispatch(
      showModalConfirm({
        title: 'Удаление',
        content: 'Вы уверены что хотите удалить пользователя?'
      })
    );

    if (res) {
      try {
        await usersActions.deleteOne(record.id);
        history.goBack();
      } catch (err) {
        console.error(err);
      }
    }
  };

  render() {
    const { children, ...rest } = this.props;
    return inChildren(children, {
      ...rest,
      notFound: this.state.notFound,
      handleUpdate: this.handleUpdate,
      handleDelete: this.handleDelete
    });
  }
}

const mapStateToProps = (state, ownProps) => {
  const { resourceName = '' } = ownProps;
  const target = state[resourceName] || {};
  const { one = {} } = target;
  return {
    record: one.data,
    loading: one.loading
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  usersActions: bindActionCreators(actions, dispatch)
});

const ContainerConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);

const View = (props) => {
  const {
    handleDelete,
    record = {},
    loading,
    match = {},
    basePath = '/',
    notFound
  } = props;

  const [tab, setTab] = React.useState(match.url);
  const itemReceived = !!(record && record.id);
  const history = useHistory();
  const back = history.goBack;
  let title = '';
  if (itemReceived) {
    title = `Пользователь: ${record.first_name} ${record.last_name}`;
  }

  const isCanUpdateUser = useCan('users:update');
  const isCanDeleteUser = useCan('users:delete');

  return (
    <Screen title={title}>
      {loading && <Progress />}
      {notFound && <NotFoundItems message="Пользователь не найден" />}
      {itemReceived && (
        <Tabs value={tab} onChange={(path) => setTab(path)}>
          <Tab label="Инфо" eventKey={match.url}>
            <Box p={2}>
              <ShowUserInfo {...props} />
            </Box>
          </Tab>
          <Tab label="Группы" eventKey={`${match.url}/groups`}>
            <Rbac operation="groups:read">
              <ShowUserGroups user_id={record.id} />
            </Rbac>
          </Tab>
          <Tab label="Сессии" eventKey={`${match.url}/sessions`}>
            <ShowUserSessions user_id={record.id} />
          </Tab>
        </Tabs>
      )}
      <FooterBar>
        <Grid item>
          <Grid container spacing={1}>
            <Grid item>
              <BackBtn onClick={back}>Назад</BackBtn>
            </Grid>
            <Grid item>
              {itemReceived && isCanUpdateUser && (
                <EditBtn to={`${basePath}/edit/${record.id}`}>
                  Редактировать
                </EditBtn>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {itemReceived && isCanDeleteUser && (
            <DeleteBtn onClick={handleDelete}>Удалить</DeleteBtn>
          )}
        </Grid>
      </FooterBar>
    </Screen>
  );
};

const Show = (props) => (
  <ContainerConnect {...props}>
    <View />
  </ContainerConnect>
);

export default Show;
